<template>
  <v-menu bottom>
    <template v-slot:activator="{ on: menu, attrs }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-chip
            v-bind="{ ...attrs, index: index }"
            v-on="{ ...tooltip, ...menu }"
            :color="value.color"
            class="schedule-chip"
            :style="!noStyle ? {
              'width': scheduleWidth(value),
              'left': scheduleLeft(value._start),
              'margin-top': `${(index * 26)}px`
            } : {}"
            dark
          >
            <v-icon small v-text="getStatus(value.status).icon" />
            {{ `${(value.customer.name).split(' ')[0]} (${value.title})` }}
          </v-chip>
        </template>
        <span v-html="`
          ${lang.scheduler.datatable.headers.customer}: #${value.customer.id} ${value.customer.name} <br />
          ${lang.scheduler.datatable.headers.service}: ${value.title} <br />
          ${lang.scheduler.datatable.headers.start}: ${formatDate(value.start)} <br />
          ${lang.scheduler.datatable.headers.end}: ${formatDate(value.end)}
        `"></span>
      </v-tooltip>
    </template>
    <v-list class="schedule-menu">
      <v-list-item class="short-view">
        <v-list-item-content class="py-2 pt-3">
          <v-list-item-title>{{ `#${value.customer.id} ${value.customer.name}` }}</v-list-item-title>
          <v-list-item-subtitle>
            <v-icon
              small
              color="blue"
            >
              mdi-phone
            </v-icon>
            <span class="text-subtitle-2 ml-1">{{ value.customer.phone | phoneMask }}</span>
          </v-list-item-subtitle>
          <v-list-item-subtitle>
            <v-icon
              small
              color="green"
            >
              mdi-card-bulleted
            </v-icon>
            <span class="text-subtitle-2 ml-1">{{ value.customer.identity | cpfMask }}</span>
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn icon>
            <v-icon>mdi-account-arrow-right</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item class="short-view">
        <v-list-item-content class="py-2">
          <v-list-item-title>{{ value.title }}</v-list-item-title>
          <v-list-item-subtitle>
            <v-icon
              small
              :color="getStatus(value.status).color"
            >
              {{ getStatus(value.status).icon }}
            </v-icon>
            <span class="text-subtitle-2 ml-1">{{ getStatus(value.status).title }}</span>
          </v-list-item-subtitle>
          <v-list-item-subtitle>
            <v-icon
              small
              color="green"
            >
              mdi-calendar-arrow-left
            </v-icon>
            <span class="text-subtitle-2 ml-1">{{ formatDate(value.start) }}</span>
          </v-list-item-subtitle>
          <v-list-item-subtitle>
            <v-icon
              small
              color="amber"
            >
              mdi-calendar-arrow-right
            </v-icon>
            <span class="text-subtitle-2 ml-1">{{ formatDate(value.end) }}</span>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item link @click.stop="$emit('view', value)">
        <v-list-item-title>{{ lang.scheduler.actions.view }}</v-list-item-title>
      </v-list-item>
      <v-list-item link @click.stop="$emit('edit', value)">
        <v-list-item-title>{{ lang.scheduler.actions.edit }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import scheduler from '../../mixins/index'

export default {
  mixins: [ appdata, utils, scheduler ],
  props: {
    value: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      default: 1
    },
    noStyle: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    scheduleWidth (schedule) {
      let start = new Date(schedule._start),
          end = new Date(schedule._end),
          difference =  Math.abs(start - end) / 36e5
      return `${(difference * 101)}%`
    },
    scheduleLeft (start) {
      let minutes = (new Date(start)).getMinutes()
      return `${((minutes / 60) * 100)}%`
    }
  }
}
</script>
